import React from 'react'

import { transformData } from '@/utils/utils'
import { TIMEOUT_MS } from '@/constants/devices'

import config from '../config'

export const useDeviceSSE = (deviceIds: (string | undefined)[]) => {
  const [dataMap, setDataMap] = React.useState<Record<string, any>>({})
  const timeoutsRef = React.useRef<Record<string, NodeJS.Timeout>>({})

  React.useEffect(() => {
    if (!deviceIds || deviceIds.length === 0) return

    const token = localStorage.getItem('accessToken')
    const idParam = deviceIds.join(',')
    const url = `${config.apiURL}/mqtt/sse/${idParam}?token=${token}`

    const eventSource = new EventSource(url)

    eventSource.onmessage = (event) => {
      try {
        const parsed = JSON.parse(event.data)
        const transformedData = transformData(parsed)

        const deviceId = parsed.deviceId
        if (deviceId) {
          setDataMap((prev) => ({ ...prev, [deviceId]: transformedData }))

          clearTimeout(timeoutsRef.current[deviceId])

          timeoutsRef.current[deviceId] = setTimeout(() => {
            setDataMap((prev) => {
              const newMap = { ...prev }
              delete newMap[deviceId]
              return newMap
            })
          }, TIMEOUT_MS)
        }
      } catch (e) {
        console.error('❌ Failed to parse SSE data:', event.data)
      }
    }

    eventSource.onerror = (err) => {
      console.error('❌ SSE connection error:', err)
      eventSource.close()
    }

    return () => {
      eventSource.close()
      Object.values(timeoutsRef.current).forEach(clearTimeout)
      timeoutsRef.current = {}
      setDataMap({})
    }
  }, [deviceIds.join(',')])

  return dataMap
}
